import Modal from 'react-modal';
import "../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from './Button';
import PropTypes from 'prop-types';
import React from 'react';

Modal.setAppElement('#root');

const CustomModal = ({ isOpen, onClose, type }) => {
    if (!['edit', 'editCommittee', 'generateReport', 'filter', 'createEvent', 'createCommittee', 'attendance', 'delete', 'reschedule','editSwag'].includes(type)) {
        console.error("Invalid modal type:", type);
        return null;
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={`${type} Modal`}
            className={`custom-modal-content ${type === 'delete' ? 'delete-modal' : ''}`}
            overlayClassName="custom-modal-overlay"
        >


            {type === 'edit' && (
                <>
                    <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                        <h2 className="text-start">Edit</h2>
                        <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                            <div className='me-3'>
                                <Button
                                    id="upload-csv-button"
                                    type={BUTTON_TYPES.primary}
                                    buttonText="Upload CSV"
                                    action={() => console.log("CSV Upload")}
                                />
                            </div>
                            <button className="close-btn" onClick={onClose}>X</button>
                        </div>
                    </div>
                </>
            )}

            {type === 'generateReport' && (
                <>
                    <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                        <h2 className="text-start">Generate Report</h2>
                        <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                            <div className='me-3'>
                                {/* will be switching to advanced report */}
                            </div>
                            <button className="close-btn" onClick={onClose}>X</button>
                        </div>
                    </div>
                    <p className="text-start">Click below to generate a report.</p>
                </>
            )}

            {type === 'filter' && (
                <>
                    <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                        <h2 className="text-start">Filter</h2>
                        <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                            <button className="close-btn" onClick={onClose}>X</button>
                        </div>
                    </div>
                    <p className="text-start">Filter Options.</p>
                </>
            )}

            {type === 'attendance' && (
                <>
                    <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                        <h2 className="text-start">Attendance</h2>
                        <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                            <button className="close-btn" onClick={onClose}>X</button>
                        </div>
                    </div>
                    <p className="text-start">Attendance information.</p>
                </>
            )}

            {type === 'reschedule' && (
                <>
                    <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                        <h2 className="text-start">Reschedule Event</h2>
                        <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                            <div className='me-3'>
                                <Button
                                    id="upload-csv-button"
                                    type={BUTTON_TYPES.primary}
                                    buttonText="Upload CSV"
                                    action={() => console.log("CSV Upload")}
                                />
                            </div>
                            <button className="close-btn" onClick={onClose}>X</button>
                        </div>
                    </div>
                    <p className="text-start">Reschedule options.</p>
                </>
            )}

            {type === 'cancel' && (
                <>
                    <h2 className="text-start">Are you sure you want to cancel?</h2>
                    <p className="text-start">Yes/no Options.</p>
                </>
            )}

            {type === 'applyChanges' && (
                <>
                    <h2 className="text-start">Your changes have been saved</h2>
                </>
            )}

            {type === 'editSwag' && (
                <>
                    <h2 className="text-start">Edit Swag Options</h2>
                    <p className="text-start">Editing Placeholder.</p>
                </>
            )}
            
        </Modal>
    );
};

CustomModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['edit', 'editCommittee', 'generateReport', 'filter', 'filterCommittees', 'createEvent', 'createCommittee', 'attendance', 'delete', 'reschedule', 'cancel', 'applyChanges', 'editSwag']).isRequired,
};

export default CustomModal;
